import React from 'react';
import { Form, MultiSelect, Button } from '@loanpal/lumos__core';
import { object, string, array } from "yup";
import { Box } from "theme-ui";
import {
  Text
} from "@aws-amplify/ui-react";

const Offers = ({ active, offerItems, offersArray = [], setInput, addSnack, readOnly, channelOfferIds }) => {
  const schema = object({
    offers: array().of(string()).min(1, "Select at least 1 offer")
  });

  const initialValues = {
    offers: offersArray ? offersArray.split(',') : []
  };

  const offerValueToId = (v) => {
    if (v == null) return "";
    if (typeof v === "string" || typeof v === "number") return String(v).trim();
    if (typeof v === "object") {
      if (v.value != null) return offerValueToId(v.value);
      if (v.id != null) return String(v.id).trim();
    }
    return "";
  };

  const handleSubmit = ({...values}) => {
    const ids = (values.offers || []).map(offerValueToId).filter(Boolean);
    setInput("offer", ids.join(","));
    addSnack("success", "Offers");
  }

  const buildOfferSelectItems = () => {
    const rows = (offerItems ?? []).map((offer) => {
      const id = offerValueToId(offer.value);
      const inChannel =
        channelOfferIds != null && channelOfferIds.has(id);
      return { offer, inChannel };
    });

    if (channelOfferIds != null) {
      rows.sort((a, b) => {
        if (a.inChannel === b.inChannel) return 0;
        return a.inChannel ? -1 : 1;
      });
    }

    return rows.map(({ offer, inChannel }) => ({
      name: inChannel ? (
        <Box
          as="span"
          sx={{
            display: "flex",
            alignItems: "flex-start",
            gap: "8px",
            lineHeight: 1.4,
          }}
        >
          <Box
            as="span"
            aria-hidden
            sx={{
              flexShrink: 0,
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              width: "14px",
              height: "14px",
              mt: "2px",
            }}
          >
            <i className="gg-check-o-green-sm" title="In channel" />
          </Box>
          <Box as="span" sx={{ flex: 1, minWidth: 0 }}>
            {offer.name}
          </Box>
        </Box>
      ) : (
        offer.name
      ),
      value: offer.value,
    }));
  };

  const OffersInput = () => {
    return (
      <>
      <Box sx={{ width: "100%", mr: 5, mt: 2 }}>
      <MultiSelect
          name="offers"
          label={<Text>
          Offer(s) Requested
          <Text as="span" fontSize="0.8rem" color="#F1C232">
              {' '}
          (optional)
          </Text>
          </Text>}
          description="Select offers and click the button below to confirm. Offers with a green check are in the channel above."
          items={buildOfferSelectItems()}
          readOnly={readOnly}
      />
      </Box>
      <Button disabled={readOnly} type="submit">Confirm Selected Offers</Button>
      </>
    )
  }

  return (
    <>
    {active &&
        <Form
          onSubmit={handleSubmit}
          validationSchema={schema}
          initialValues={initialValues}>
            <OffersInput />
        </Form>
    }
    </>
  )
}

export default Offers;